import React from 'react';

import './advanced-product-card.scss';
import { IProductDescription } from '../../../models/product/IProductDescription';
import ProductCover from '../productCover/ProductCover';
import { ImageDisplayType } from '../PlaceholderImage';

export interface IProps {
    coverPlaceholder: string;
    wideCoverPlaceholder: string;
    
    productDescription: IProductDescription;
    style?: React.CSSProperties;

    isInAtLeastOneReadingList?: boolean;

    onOutsideClick?: () => void;
    outsideClickIgnoredElementsSelector?: string;

    onAddToReadingListRequest?: (productDescription: IProductDescription) => void;
}

export interface IState {

}

export class AdvancedProductCard extends React.Component <IProps, IState> {
    private root: HTMLElement;
    private hasBeenMounted: boolean;
    
    constructor(props: IProps){
        super(props);

        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleRootRef = this.handleRootRef.bind(this);
        this.handleAddToReadingListRequest = this.handleAddToReadingListRequest.bind(this);
    }

    public render(){
        const productDescription = this.props.productDescription;
        
        return <div className="advanced-product-card" 
                    style={this.props.style} 
                    ref={this.handleRootRef}>
                    <div className="advanced-product-card-header">
                        <h5 dangerouslySetInnerHTML={{__html: productDescription.title}}></h5>
                    </div>
                    <div className="advanced-product-card-content-container">
                        <div className="advanced-product-card-left-column">
                            <ProductCover placeholderImage = {productDescription.isWideCover ? this.props.wideCoverPlaceholder : this.props.coverPlaceholder}
                                          imageDisplayType = {ImageDisplayType.Image}
                                          fullImage = {productDescription.coverPath}
                                          className={productDescription.isWideCover ? "wide-screen-image" : ""}
                                          height={150}
                                          width={120}
                                          alt = {productDescription.title}
                                          placeholderOnlyOnFail={false}
                                          isLiveaudio={productDescription.isLiveaudio}/>
                            <a className="advanced-product-card-read-now-link" href={productDescription.contentLink || productDescription.marketplaceLink || productDescription.link} target="_blank">read now</a>
                            <button className="advanced-product-card-reading-list-button" onClick={this.handleAddToReadingListRequest}>
                                {this.renderReadingListButtonLabel()}
                            </button>
                        </div>
                        <div className="advanced-product-card-right-column" dangerouslySetInnerHTML={{__html: productDescription.description}}>
                        </div>
                    </div>
               </div>
    }

    private handleRootRef(root: HTMLElement){
        this.root = root;
    }

    public componentDidMount(){
        this.hasBeenMounted = true;

        document.addEventListener("click", this.handleDocumentClick);
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;

        document.removeEventListener("click", this.handleDocumentClick);
    }

    private handleDocumentClick(e){
        const target = e.target as HTMLElement;

        if(this.root.contains(target)){ return; }
        if(this.props.outsideClickIgnoredElementsSelector 
        && target.matches(this.props.outsideClickIgnoredElementsSelector)){
            return;
        }
        
        this.props.onOutsideClick && this.props.onOutsideClick();
    }

    private renderReadingListButtonLabel() {
        return this.props.isInAtLeastOneReadingList ? "edit reading lists" : "add to reading list";
    }

    private handleAddToReadingListRequest(){
        this.props.onAddToReadingListRequest && this.props.onAddToReadingListRequest(this.props.productDescription);
    }
}
